import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Flex, Box } from '@elparking/components'

import {
    AirportServiceBox,
    AirportServiceTimeBox,
    AirportMessageBlockIcon,
    AirportMessageBlockDescription,
    AirportMessageBlockTransferTime,
} from './layout'
import {
    PARKING_BOOKING_SERVICE_TYPE_AIRPORT_TRANSFER,
    PARKING_BOOKING_SERVICE_TYPE_PICK_UP,
    PARKING_BOOKING_SERVICE_TYPE_WALKING,
} from 'commons/js/constants'

const AIRPORT_TRANSPORT_SERVICES = [
    PARKING_BOOKING_SERVICE_TYPE_AIRPORT_TRANSFER,
    PARKING_BOOKING_SERVICE_TYPE_PICK_UP,
    PARKING_BOOKING_SERVICE_TYPE_WALKING,
]

const byLowestPriceAsc = (service, otherService) => Math.sign(service.priceQty.amount - otherService.priceQty.amount)

const getCheapestBookingService = (bookingServices) => bookingServices
    .filter(({ type }) => AIRPORT_TRANSPORT_SERVICES.includes(type))
    .sort(byLowestPriceAsc)
    .slice(0, 1)
    .shift()

const AirportTransfer = ({ transferTime, transferTimeFrequency }) => (
    <Flex flexDirection='column' mb={['1em', '0', '0']}>
        <AirportServiceBox flex='1' px='1em' py='0.5em'>
            <Flex alignItems='center'>
                <Box>
                    <AirportMessageBlockIcon type='bus-filled' color='gray' size='large' />
                </Box>
                <Box pl='0.5em'>
                    <AirportMessageBlockDescription>
                        <FormattedMessage
                          defaultMessage='Traslado a la terminal'
                        />
                    </AirportMessageBlockDescription>
                </Box>
            </Flex>
        </AirportServiceBox>
        <AirportServiceTimeBox flex='1' px='1em' py='0.5em'>
            <AirportMessageBlockTransferTime>
                {transferTime} | {transferTimeFrequency}
            </AirportMessageBlockTransferTime>
        </AirportServiceTimeBox>
    </Flex>
)

AirportTransfer.propTypes = {
    transferTime: PropTypes.string,
    transferTimeFrequency: PropTypes.string,
}

const Pickup = () => (
    <AirportServiceBox px='1em' py='0.5em' mb={['1em', '0', '0']}>
        <Flex alignItems='center'>
            <Box>
                <AirportMessageBlockIcon type='valet' color='gray' size='large' />
            </Box>
            <Box flex='1' pl='0.5em'>
                <AirportMessageBlockDescription>
                    <FormattedMessage
                      defaultMessage='Valet - Aparcacoches'
                    />
                </AirportMessageBlockDescription>
            </Box>
        </Flex>
    </AirportServiceBox>
)

const Walking = ({ transferTime }) => (
    <AirportServiceBox px='1em' py='0.5em' mb={['1em', '0', '0']}>
        <Flex alignItems='center'>
            <Box>
                <AirportMessageBlockIcon type='walk' color='gray' size='large' />
            </Box>
            <Box flex='1' pl='0.5em'>
                <AirportMessageBlockDescription>
                    <FormattedMessage
                      defaultMessage='Traslado a pie'
                    />
                </AirportMessageBlockDescription>
            </Box>
            <Box pl='1em'>
                <AirportMessageBlockTransferTime>
                    {transferTime}
                </AirportMessageBlockTransferTime>
            </Box>
        </Flex>
    </AirportServiceBox>
)

Walking.propTypes = {
    transferTime: PropTypes.string,
}

const ParkingAirportService = ({ bookingServices }) => {
    const bookingService = getCheapestBookingService(bookingServices)

    if (!bookingService) {
        return null
    }

    const { type, transferTime, transferTimeFrequency } = bookingService

    switch (type) {
        case PARKING_BOOKING_SERVICE_TYPE_AIRPORT_TRANSFER:
            return <AirportTransfer transferTime={transferTime} transferTimeFrequency={transferTimeFrequency} />
        case PARKING_BOOKING_SERVICE_TYPE_PICK_UP:
            return <Pickup />
        case PARKING_BOOKING_SERVICE_TYPE_WALKING:
            return <Walking transferTime={transferTime} />
        default:
            return null
    }
}

ParkingAirportService.propTypes = {
    bookingServices: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.number,
        priceQty: PropTypes.shape({
            amount: PropTypes.number,
        }),
        transferTime: PropTypes.string,
        transferTimeFrequency: PropTypes.string,
    })),
}

ParkingAirportService.defaultProps = {
    bookingServices: [],
}

export default ParkingAirportService
